export default __webpack_public_path__ + "static/media/arrow-left.7e80b848.svg";